import { graphql, useStaticQuery } from "gatsby";

import { SellBanner } from "../components/blocks/sell-banner";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean => {
  return __typename === "VinoData_StaticBlock" && staticType === "Sell Banner";
};

const create = (props: {
  __typename: string;
  staticType: string;
}): JSX.Element => {
  return <SellBanner />;
};

export default { test, create };
